import {
  Weekly,
  Monthly,
  BiMonthly,
  BiWeekly,
  Daily,
  Refused,
  ZeroFreq,
  Discontinued,
} from '@mummssoftware/utils/frequencies/frequency-constants';
import {
  AideRoleGroupId,
  VolunteerRoleGroupId,
} from '@mummssoftware/utils/roleData';

export const isAideOrVolunteerRoleGroup = (roleGroupId: number | string) => {
  const id = Number(roleGroupId);
  return id === AideRoleGroupId || id === VolunteerRoleGroupId;
};

/** Plans with an endDate are closed — do not allow widget edit/save. */
export const hasEndDate = (carePlan?: mumms.ProcessedCarePlan | null) =>
  Boolean(carePlan?.endDate);

/** Clear in-progress inline/order cell edits on the live plan object. */
export const clearCarePlanEdits = (
  carePlan?: mumms.ProcessedCarePlan | null,
) => {
  if (!carePlan) return;
  delete (carePlan as { editPeriod?: string }).editPeriod;
  delete (carePlan as { editFrequency?: string | number }).editFrequency;
  delete (carePlan as { editEffective?: Date }).editEffective;
  // Delete (do not set '') so a later save refill treats days as unset —
  // `''.split(',')` is truthy and would skip refill from daysOfWeek.
  delete (carePlan as { editDaysOfWeek?: string }).editDaysOfWeek;
  if ('editPrn' in carePlan) {
    carePlan.editPrn = carePlan.prn ?? null;
  }
};

export type CarePlanDisplaySnapshot = {
  period: string;
  frequency: mumms.ProcessedCarePlan['frequency'];
  frequencyText: string;
  daysOfWeek: string;
  effectiveDate?: string;
};

export const snapshotCarePlanDisplay = (
  carePlan: mumms.ProcessedCarePlan,
): CarePlanDisplaySnapshot => ({
  period: carePlan.period,
  frequency: carePlan.frequency,
  frequencyText: carePlan.frequencyText,
  daysOfWeek: carePlan.daysOfWeek || '',
  effectiveDate: carePlan.effectiveDate,
});

export const restoreCarePlanDisplay = (
  carePlan: mumms.ProcessedCarePlan,
  snapshot: CarePlanDisplaySnapshot,
) => {
  carePlan.period = snapshot.period;
  carePlan.frequency = snapshot.frequency;
  carePlan.frequencyText = snapshot.frequencyText;
  carePlan.daysOfWeek = snapshot.daysOfWeek;
  carePlan.effectiveDate = snapshot.effectiveDate;
};

export const isFreqNotEditable = (editPeriod: string | null) =>
  editPeriod &&
  (editPeriod === Refused ||
    editPeriod === ZeroFreq ||
    editPeriod === Discontinued);

export const isFreqEditable = (editPeriod: string | null) =>
  editPeriod &&
  (editPeriod === Weekly ||
    editPeriod === Monthly ||
    editPeriod === BiMonthly ||
    editPeriod === BiWeekly);

export const isFreqNoEditDay = (editPeriod: string | null) =>
  editPeriod &&
  editPeriod !== Weekly &&
  editPeriod !== Monthly &&
  editPeriod !== BiMonthly &&
  editPeriod !== BiWeekly;
